<template lang='pug'>
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование шага" : "Добавление шага"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12 sm4)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12 sm4)
          v-text-field(
            :error='errors.has("alias")'
            :error-messages='errors.first("alias")'
            v-model='item.alias'
            label='Алиас'
          )
        v-flex(xs12 sm4)
          v-text-field(
            :error='errors.has("alt")'
            :error-messages='errors.first("alt")'
            v-model='item.alt'
            label='Альтернативное навзание'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("text")'
            :error-messages='errors.first("text")'
            v-model='item.text'
            label='Текст'
          )
        v-flex(xs12)
          div(class='subheading font-weight-medium mb-3') HTML
          ckeditor(v-model='item.html')
        v-flex(xs12)
          s-sortable(
            @change='onFilesSort'
            @remove='onFileRemove'
            :sortable='item.images_list'
            :openable='true'
            :deletable='true'
          )
        v-flex(xs12)
          dropzone(v-model='files' @error='onFileError')
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor'),
    Dropzone: () => import('@/components/async/Dropzone')
  },

  data: () => ({
    item: {},
    files: {}
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      this.item = (await this.fetchSingle({ id: this.id })).data
    },

    async onSave() {
      let data = this.createFormData()

      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.files = {}

        this.$nextTick(() => {
          this.$root.showSnack('Шаг сохранен')
          this.$router.push({ name: 'Admin.Steps' })
        })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async onFilesSort(files) {
      if (!this.isLoading) {
        try {
          await this.sortFiles(files.map(x => x.hash))
        } catch (e) {
          this.$root.showSnack('Ошибка сортировки файлов')
        }
      }
    },

    async onFileRemove({ hash }) {
      if (!this.isLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.removeFile(hash)
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления файла')
        }
      }
    },

    createFormData() {
      let data = new FormData()

      data.append('images', Object.keys(this.files))

      Object.keys(this.item).forEach(key => {
        data.append(key, this.item[key])
      })

      return data
    },

    onFileError() {
      this.$root.showSnack('Ошибка загрузки файла')
    },

    ...mapActions('admin/steps', [
      'fetchSingle',
      'update',
      'create',
      'sortFiles',
      'removeFile'
    ])
  },

  computed: {
    ...mapGetters('admin/steps', ['isLoading'])
  }
}
</script>
